import { IUser } from '../../../../interfaces/models/user'

const MS_PER_DAY = 86400000

/** `REACT_APP_TRAIN_AI_MODAL_REMINDER_DAYS` — days after Skip before auto-showing the modal again. */
export function getTrainAiModalReminderDays(): number {
    const n = Number(process.env.REACT_APP_TRAIN_AI_MODAL_REMINDER_DAYS ?? '7')
    return Number.isFinite(n) && n > 0 ? n : 7
}

/**
 * Auto-open only if user has not trained AI (`conversationsRecordedForAi` is not true).
 * If they skipped before, wait until `REACT_APP_TRAIN_AI_MODAL_REMINDER_DAYS` since `trainAiInboxModalSkippedAt`.
 */
export function shouldAutoOpenTrainAiModal(user: IUser | undefined | null): boolean {
    if (!user) return false
    if (user.conversationsRecordedForAi === true) {
        return false
    }
    if (!user.trainAiInboxModalSkippedAt) {
        return true
    }
    const skippedAt = new Date(user.trainAiInboxModalSkippedAt).getTime()
    if (Number.isNaN(skippedAt)) {
        return true
    }
    const daysSinceSkip = (Date.now() - skippedAt) / MS_PER_DAY
    return daysSinceSkip >= getTrainAiModalReminderDays()
}
